export default __webpack_public_path__ + "locales/es/SalesDepartmentRequestDialog.json?hash=3a5036a01898ec3514107d01be288631";